export default [
    {
      path: "/managerlist",
      name: "managerlist",
      component: () => import(/* webpackChunkName: "account" */ "../views/manager/vManagerList.vue"),
      meta: { title: "Manager", auth: true, roles: [10, 20] },
    },
  ];
  